// extracted by mini-css-extract-plugin
module.exports = {"root":"reservation-module--root--2a8o_"};